const legacyNotificationTypes = ['mrequest'];

export const filterLegacyNotifications = (notifications) =>
  Array.isArray(notifications)
    ? notifications.filter(
        (notification) => !isLegacyNotification(notification)
      )
    : [];

export const getRequestNotificationMessage = (notification) => {
  const { type_notification: type } = notification;
  const basePath = 'notifications.messages.schedule_impact_request';
  const messageMap = {
    pending: `${basePath}.pending_request_received`,
    approved: `${basePath}.pending_request_approved`,
    rejected: `${basePath}.pending_request_rejected`
  };
  const description = messageMap[type];
  return description;
};

export const getRequestIdFromLink = (link) => {
  if (!link) {
    return null;
  }
  const urlRegex = /\d+\/project\/\d+\/schedule\/\d+\/request\/\w+\/(\d+)/;
  const match = link.match(urlRegex);
  return match ? parseInt(match[1]) : null;
};

export const getNotificationLink = ({
  orgId,
  notification,
  notificationData,
  selectedProject
}) => {
  if (!notification || !notificationData) {
    return null;
  }

  const {
    module,
    type_notification: type,
    projectId,
    sectorId: scheduleId
  } = notification;
  const { link, organizationId } = notificationData;

  if (module === 'scheduleimpactrequest') {
    return getScheduleURL({ orgId: organizationId, projectId, scheduleId });
  }
  if (module === 'tasks') {
    return getLookaheadURL({ orgId, projectId, scheduleId });
  }
  if (module === 'constraints' || module === 'procore') {
    return getRoadblocksURL({ orgId, projectId, scheduleId });
  }
  if (!selectedProject && type !== 'report_analytics') {
    return null;
  }
  return link;
};

const getScheduleURL = ({ orgId, projectId, scheduleId }) =>
  `/${orgId}/project/${projectId}/schedule/${scheduleId}/`;

const getLookaheadURL = ({ orgId, projectId, scheduleId }) =>
  `/${orgId}/project/${projectId}/schedule/${scheduleId}/lookahead`;

const getRoadblocksURL = ({ orgId, projectId, scheduleId }) =>
  `/${orgId}/project/${projectId}/schedule/${scheduleId}/lookahead/roadblocks`;

const isLegacyNotification = (notification) =>
  legacyNotificationTypes.includes(notification.type_notification);
